/**
 * Request fields naming the chosen sample recipient; empty for sample data.
 * @param {{crmContactId?: string, crmCompanyId?: string}|null} recipient
 * @returns {{crmContactId: string}|{crmCompanyId: string}|{}}
 */
export const sampleRecipientRef = (recipient) => {
	if (recipient?.crmContactId) return { crmContactId: recipient.crmContactId };
	if (recipient?.crmCompanyId) return { crmCompanyId: recipient.crmCompanyId };
	return {};
};
